import {PearlHarborSymbol} from "../reels/PearlHarborSymbol";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {PearlHarbor} from "../PearlHarbor";
import {TimelineLite} from "gsap";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {PearlHarborSoundManager} from "../sound/PearlHarborSoundManager";
import {PearlHarborScatterSymbol} from "../reels/PearlHarborScatterSymbol";
import {PearlHarborHelper} from "../utils/PearlHarborHelper";

export class ScatterAnimation extends PIXI.Container implements StageLayer {
    private _isAnticipationRunning: boolean = false;
    private _scatters: PearlHarborScatterSymbol[];
    private _mainTl: TimelineLite | null;

    constructor() {
        super();
        this.name = "Scatter Animation";
        this._scatters = [];
    }

    public playTriggerAnim(): TimelineLite {
        //This animation is played when you get 3 scatters but not stopped to enter to fs
        const tl: TimelineLite = new TimelineLite();
        this._scatters.forEach((symbol: PearlHarborScatterSymbol) => {
            if (symbol.isActivated) {
                tl.add(symbol.playScatterTriggerAnim(), 0);
            }
        });
        return tl;
    }

    public playWinAnim(): TimelineLite {
        //This animation is played when ready to enter fs
        const tl: TimelineLite = new TimelineLite();
        this._scatters.forEach((symbol: PearlHarborScatterSymbol) => {
            if (symbol.isActivated) {
                tl.add(symbol.playScatterWinAnim(), 0);
            }
        });
        tl.add(() => {
            PearlHarborSoundManager.playScatterTrigger();
        }, 0);
        return tl;
    }

    public checkActiveScatter(): TimelineLite {
        return new TimelineLite().add(() => {
            this._scatters.forEach((symbol: PearlHarborScatterSymbol) => {
                if (!symbol.isActivated && PearlHarborHelper.isActiveCell(symbol.reelId, symbol.reelTargetPosition)) {
                    symbol.isActivated = true;
                    PearlHarbor.scatterCounter.enableCounter();
                }
            });
        });
    }

    public addScatter(symbol: PearlHarborScatterSymbol): void {
        this._scatters.push(symbol);
    }

    public playAnticipation(): void {
        if (PearlHarbor.model.data.wasFeatureBuy) {
            return;
        }
        PearlHarborSoundManager.playScatterAnticipation();
        this._isAnticipationRunning = true;
        this._scatters.forEach((symbol: PearlHarborScatterSymbol) => {
            if (symbol.isActivated) {
                symbol.playScatterAnticipationAnim();
            }
        });
    }

    public stopAnticipation(): void {
        if (this._isAnticipationRunning) {
            if (PearlHarbor.model.scatterCount >= 3) {
                PearlHarborSoundManager.playScatterAnticipationComplete();
            } else {
                PearlHarborSoundManager.playScatterAnticipationFail();
            }
            this._isAnticipationRunning = false;
            //this._scatters.forEach((symbol: PearlHarborScatterSymbol) => {
            //    if (symbol.isActivated) {
            //        symbol.stopScatterAnticipationAnim();
            //    }
            //});
        }
    }

    public onSpinStop(): void {
        if (this._mainTl) {
            if (this._mainTl.isActive()) {
                this._mainTl.paused();
                this._mainTl.kill();
            }
            this._mainTl = null;
        }
        this._mainTl = new TimelineLite();
        this.removeChildren();
    }

    public onSpinStart(): void {
        if (this._mainTl) {
            if (this._mainTl.isActive()) {
                this._mainTl.paused();
                this._mainTl.kill();
            }
            this._mainTl = null;
        }
        this._scatters = [];
    }
}